import './utilities/instrument';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { reactErrorHandler } from '@sentry/react';

import App from './App';
import { PersonalisationProvider } from './context/PersonalisationContext';
import { LocaleProvider } from './context/LocaleContext';

import './components/personalisation-global.css';

const container = document.getElementById('react-personalisation-ui');

if (!container) {
  throw new Error('Container element with id "react-personalisation-ui" not found');
}

createRoot(container, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler()
}).render(
  <StrictMode>
    <PersonalisationProvider>
      <LocaleProvider>
        <App />
      </LocaleProvider>
    </PersonalisationProvider>
  </StrictMode>
);
